import { docStatusFor } from "@/lib/format";

export function StatusBadge({ status, label, testId }) {
  const cls =
    status === "success"
      ? "status-success"
      : status === "warning"
      ? "status-warning"
      : status === "danger"
      ? "status-danger"
      : "status-neutral";
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`${cls} inline-flex items-center px-3 py-1 text-xs font-bold uppercase tracking-wider`}
    >
      {label}
    </span>
  );
}

export function DocExpiryBadge({ expiryDate, testId }) {
  const s = docStatusFor(expiryDate);
  return <StatusBadge status={s.color} label={s.label} testId={testId} />;
}

export function VehicleStatusBadge({ status }) {
  const map = {
    available: { color: "success", label: "Disponible" },
    leased: { color: "warning", label: "Arrendado" },
    in_workshop: { color: "neutral", label: "En Taller" },
    out_of_service: { color: "danger", label: "Fuera de Servicio" },
  };
  const m = map[status] || { color: "neutral", label: status };
  return <StatusBadge status={m.color} label={m.label} testId={`vehicle-status-${status}`} />;
}
